var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h1',{staticClass:"topic-title"},[_vm._v("분야를 선택하세요")]),_vm._v(" "),_vm._l((_vm.sections),function(section,index){return _c('categoryitem',{key:index,attrs:{"index":index,"section_name":section,"sectionStates":_vm.sectionStates[index]}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71ee4612","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/categoryList.vue
// module id = null
// module chunks = 